import React, {useEffect} from "react";
import {useSearchParams} from 'react-router-dom';
import {getCookie, setCookie, simplePutData} from '../../utils/Functions';
import EndPoint from "../../api/Endpoints";

import bgGirlStadium from "../../assets/imgs/unicef/messi/thankyou/bg-girl-stadium.png";
import confetti from "../../assets/imgs/unicef/messi/thankyou/confetti.png";
import unicefLogo from "../../assets/imgs/unicef/messi/thankyou/unicef-logo-white.png";

import "./MessiThankYou.css";

const MessiThankYou = () => {
    const [searchParams] = useSearchParams();
    const name = searchParams.get("name") || "";
    const email = searchParams.get("email") || "";
    const amount = searchParams.get("amount") || "";

    useEffect(() => {
        window.fbq('track', 'Purchase', {value: amount ? parseFloat(amount) : 1.00, currency: 'BOB'});

        const date = new Date();
        const timestamp = date.getTime();
        window.gtag("event", "purchase", {
            transaction_id: timestamp,
            value: amount ? parseFloat(amount) : 1.00,
            currency: "BOB",
            items: [{
                item_id: "SKU_DONACION_UNICA_MESSI",
                item_name: "Donación Única Sorteo Messi",
                price: amount ? parseFloat(amount) : 1.00,
                quantity: 1
            }]
        });

        var _tmpOrder = getCookie(process.env.REACT_APP_NAME + "_DFP_session_id");
        let utm_source = getCookie(process.env.REACT_APP_NAME + "utm_source");
        let stepValues = {
            step: "checkout-finish-OK",
            utm_source: utm_source,
            email: email,
            sessionid: _tmpOrder
        };
        simplePutData(EndPoint.setStep, stepValues);

        setTimeout(() => {
            window.scrollTo(0, 0);
            setCookie(process.env.REACT_APP_NAME + "utm_source", "", 0.5);
            setCookie(process.env.REACT_APP_NAME + "utm_id", "", 0.5);
            setCookie(process.env.REACT_APP_NAME + "utm_content", "", 0.5);
            setCookie(process.env.REACT_APP_NAME + "utm_medium", "", 0.5);
            setCookie(process.env.REACT_APP_NAME + "utm_campaign", "", 0.5);
            setCookie(process.env.REACT_APP_NAME + "utm_term", "", 0.5);
        }, 100);
    }, []);

    const ticketCount = amount ? Math.floor(parseFloat(amount) / 50) : 0;

    return (
        <div className="messi-thankyou">
            <img src={bgGirlStadium} alt="" className="messi-thankyou-bg"/>
            <img src={confetti} alt="" className="messi-thankyou-confetti"/>

            <div className="messi-thankyou-content">
                <div className="messi-thankyou-left">
                    <img src={unicefLogo} alt="UNICEF" className="messi-thankyou-logo"/>

                    <h1 className="messi-thankyou-name font-face-UniversBold">
                        {name}
                    </h1>
                    <h2 className="messi-thankyou-title font-face-UniversBold">
                        Gracias por jugar por la infancia
                    </h2>

                    <p className="messi-thankyou-text">
                        Hoy hiciste mucho m&aacute;s que una donaci&oacute;n.<br/>
                        Hoy le diste una oportunidad a una ni&ntilde;a o un ni&ntilde;o
                        de construir un futuro mejor.
                    </p>

                    <div className="messi-thankyou-email-box">
                        <p>Enviamos el comprobante de tu donaci&oacute;n &uacute;nica al correo:</p>
                        <strong>{email}</strong>
                    </div>

                    <div className="messi-thankyou-sorteo-box">
                        <p>
                            Cada boliviano que donas ayuda a que m&aacute;s ni&ntilde;as y ni&ntilde;os
                            tengan acceso a salud, educaci&oacute;n, protecci&oacute;n y un futuro lleno
                            de posibilidades.
                        </p>
                        <br/>
                        <p>
                            Adem&aacute;s, con tu donaci&oacute;n ya est&aacute;s participando en el sorteo
                            de una polera oficial del FC Barcelona <strong>firmada por Lionel Messi</strong>.
                            {ticketCount > 0 && (
                                <><br/><br/>Tienes <strong>{ticketCount} ticket{ticketCount !== 1 ? 's' : ''}</strong> para el sorteo.</>
                            )}
                        </p>
                    </div>

                    <div className="messi-thankyou-bottom">
                        <p>
                            Por tu generosidad, gracias y la Ni&ntilde;ez te lo har&aacute; realidad:
                            los sue&ntilde;os de quienes deciden cambiar vidas.
                        </p>
                    </div>

                    <p className="messi-thankyou-footer-text font-face-UniversBold">
                        Gracias porque cuando juegas por la<br/>infancia, todos ganamos.
                    </p>
                </div>
            </div>
        </div>
    );
};

MessiThankYou.propTypes = {};

export default MessiThankYou;
